<template>
  <div>
    <PageTitle title="Edit Role" />
    <v-row>
      <v-col>
        <v-breadcrumbs divider=">" class="px-0 pt-0 breadcrumbs">
          <v-breadcrumbs-item
            v-for="item in navSettingsOptions"
            :key="item.index"
          >
              <span
                class="text-breadcum-settings"
                v-if='!item.to'
              >
                {{ item.text }}
                <v-icon style="font-size: 1.2rem">mdi-chevron-right</v-icon>
              </span>
            <router-link
              class="text-breadcum-settings"
              v-else
              :to='item.to'
            >
              {{ item.text }}
              <v-icon style="font-size: 1.2rem">mdi-chevron-right</v-icon>
            </router-link>
          </v-breadcrumbs-item>
        </v-breadcrumbs>
      </v-col>
    </v-row>
    <div class="alerts-wrapper" v-if="isSystem">
      <div class="alerts-wrapper__icon">
        <v-img width="24px" height="24px" src="@/assets/icons/svg/alert.svg" />
      </div>
      <div class="alerts-wrapper__text">
        This role is cannot be changed
      </div>
    </div>
    <div class="home-content">
      <v-row class='mt-2 px-2'>
        <v-col>
          <v-tabs
            v-model="activeTab"
            class='roles-tabs'
            background-color='transparent'
          >
            <v-tabs-slider
              color='#f5f5f5'
            />
            <v-tab
              v-for='(item, key) in tabsItems'
              :key='key'
              class='roles-tab'
            >
              {{item.title}}
            </v-tab>
          </v-tabs>
        </v-col>
      </v-row>
      <v-row class='mt-2'>
        <v-col>
          <v-tabs-items
            v-model='activeTab'
            class='bg-transparent'
            continuous
          >
            <v-tab-item transition='scroll-x-transition'>
              <template>
                <div class="header-content px-2">Info</div>
                <v-row class='mt-2 px-2'>
                  <v-col cols='12'>
                    <v-form v-model='valid'>
                      <v-row>
                        <v-col cols='7'>
                          <img
                            class="image-icon left"
                            src="@/assets/icons/svg/pencil2.svg"
                          />
                          <span class="label-text">Role name *</span>
                          <div class="input-mb input-box input-box d-flex flex-nowrap">
                            <v-text-field
                              dense
                              placeholder="Enter Role Name..."
                              v-model="item.name"
                              :rules='nameRules'
                              color="#43425d"
                              maxlength="128"
                              class="r-field item-name-field"
                              :disabled='item.system'
                            />
                          </div>
                        </v-col>
                      </v-row>
                      <v-row class='mt-2'>
                        <v-col cols='7'>
                          <img
                            class="image-icon left"
                            src="@/assets/icons/svg/pencil2.svg"
                          />
                          <span class="label-text">Description</span>
                          <div class="input-mb input-box input-box d-flex flex-nowrap">
                            <v-textarea
                              dense
                              placeholder="Enter Role Name..."
                              v-model="item.description"
                              color="#43425d"
                              maxlength="128"
                              class="r-field item-name-field"
                              :disabled='item.system'
                            />
                          </div>
                        </v-col>
                      </v-row>
                      <v-row class='mt-2'>
                        <v-col cols='12'>
                          <div class="header-content">Setting Up Access Rights</div>
                          <div class='table-wrapper mt-1' style="background-color: #efefef">
                            <v-data-table
                              :headers="setupAccessRightsHeaders"
                              :items="setupAccessRightsItems"
                              class="cursor-point relative-position"
                              hide-default-footer
                              :disabled='isSystem'
                            >
                              <template
                                v-if="itemIsLoading"
                                v-slot:body
                              >
                                <tbody>
                                  <div class="justify-center flex flex-center flex-column full-width">
                                    <circle-progress class="mt-16" />
                                  </div>
                                </tbody>
                              </template>
                              <template v-slot:[`item.fullAccess`]="{ item }">
                                <v-simple-checkbox
                                  v-model="item.fullAccess"
                                  @input='v => {handleAccessRightsItemChange(item.name, "fullAccess", v)}'
                                  color="#7972c0"
                                  :ripple="false"
                                  :disabled='isSystem'
                                />
                              </template>
                              <template v-slot:[`item.view`]="{ item }">
                                <v-simple-checkbox
                                  v-model="item.view"
                                  @input='v => {handleAccessRightsItemChange(item.name, "view", v)}'
                                  color="#7972c0"
                                  :ripple="false"
                                  :disabled='isSystem'
                                />
                              </template>
                              <template v-slot:[`item.create`]="{ item }">
                                <v-simple-checkbox
                                  v-model="item.create"
                                  @input='v => {handleAccessRightsItemChange(item.name, "create", v)}'
                                  color="#7972c0"
                                  :ripple="false"
                                  :disabled='isSystem'
                                />
                              </template>
                              <template v-slot:[`item.edit`]="{ item }">
                                <v-simple-checkbox
                                  v-model="item.edit"
                                  @input='v => {handleAccessRightsItemChange(item.name, "edit", v)}'
                                  color="#7972c0"
                                  :ripple="false"
                                  :disabled='isSystem'
                                />
                              </template>
                              <template v-slot:[`item.delete`]="{ item }">
                                <v-simple-checkbox
                                  v-model="item.delete"
                                  @input='v => {handleAccessRightsItemChange(item.name, "delete", v)}'
                                  color="#7972c0"
                                  :ripple="false"
                                  :disabled='isSystem'
                                />
                              </template>
                            </v-data-table>
                          </div>
                        </v-col>
                      </v-row>
                      <v-row class='mt-2'>
                        <v-col cols='12'>
                          <div class="header-content">Access Rights</div>
                          <div class='table-wrapper mt-1' style="background-color: #efefef">
                            <v-data-table
                              :headers="accessRightsHeaders"
                              :items="accessRightsItems"
                              class="cursor-point relative-position"
                              hide-default-footer
                              :disabled='isSystem'
                            >
                              <template
                                v-if="itemIsLoading"
                                v-slot:body
                              >
                                <tbody>
                                  <div class="justify-center flex flex-center flex-column full-width">
                                    <circle-progress class="mt-16" />
                                  </div>
                                </tbody>
                              </template>
                              <template v-slot:[`item.active`]='{item}'>
                                <v-checkbox
                                  v-if='item.name === "Import"'
                                  v-model="accessRightsImport"
                                  color="#7972c0"
                                  hide-details
                                  class='mt-0'
                                  :ripple="false"
                                  :disabled='isSystem'
                                />
                                <v-checkbox
                                  v-if='item.name === "Export"'
                                  v-model="accessRightsExport"
                                  color="#7972c0"
                                  hide-details
                                  class='mt-0'
                                  :ripple="false"
                                  :disabled='isSystem'
                                />
                                <v-checkbox
                                  v-if='item.name === "Reports"'
                                  v-model="accessRightsReports"
                                  color="#7972c0"
                                  hide-details
                                  class='mt-0'
                                  :ripple="false"
                                  :disabled='isSystem'
                                />
                                <v-checkbox
                                  v-if='item.name === "Alerts Management"'
                                  v-model="accessRightsAlertsManagement"
                                  color="#7972c0"
                                  hide-details
                                  class='mt-0'
                                  :ripple="false"
                                  :disabled='isSystem'
                                />
                                <v-checkbox
                                  v-if='item.name === "Role Management"'
                                  v-model="accessRightsRoleManagement"
                                  color="#7972c0"
                                  hide-details
                                  class='mt-0'
                                  :ripple="false"
                                  :disabled='isSystem'
                                />
                                <v-checkbox
                                  v-if='item.name === "Activity History"'
                                  v-model="accessRightsActivityHistory"
                                  color="#7972c0"
                                  hide-details
                                  class='mt-0'
                                  :ripple="false"
                                  :disabled='isSystem'
                                />
                                <v-checkbox
                                  v-if='item.name === "User Management"'
                                  v-model="accessRightsUserManagement"
                                  color="#7972c0"
                                  hide-details
                                  class='mt-0'
                                  :ripple="false"
                                  :disabled='isSystem'
                                />
                                <v-checkbox
                                  v-if='item.name === "Integration Management"'
                                  v-model="accessRightsIntegrationManagement"
                                  color="#7972c0"
                                  hide-details
                                  class='mt-0'
                                  :ripple="false"
                                  :disabled='isSystem'
                                />
                              </template>
                            </v-data-table>
                          </div>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-col>
                </v-row>
              </template>
            </v-tab-item>
            <v-tab-item transition='scroll-x-transition'>
              <div class="header-content px-2">Users with this role</div>
              <v-row class='mt-2 px-2'>
                <v-col cols='12'>
                  <div class="table-wrapper mt-6">
                    <v-row class="table-controls mb-1 items-center">
                      <v-col cols="12">
                        <v-menu
                          class='select-warehouse-body'
                          min-width='220'
                          transition="slide-y-transition"
                          :close-on-content-click='false'
                          offset-y
                          bottom
                          right
                          v-model='addingUserMenuState'
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              depressed
                              v-bind="attrs"
                              v-on="on"
                              color='#8074c2'
                              class='px-4 text-white'
                            >
                              Assign users
                              <v-icon>
                                mdi-chevron-down
                              </v-icon>
                            </v-btn>
                          </template>
                          <div class='bg-white pb-4'>
                            <v-col
                              class='py-0 px-4'
                            >
                              <v-text-field
                                v-model='searchUsersInput'
                                placeholder='Search...'
                                hide-details
                                autocomplete="off"
                                class='mt-0 pt-2'
                              />
                            </v-col>
                            <div class='to-selecting-list mt-2'>
                              <v-list
                                v-if='filtredUsersList.length'
                                max-height='150'
                              >
                                <v-list-item
                                  v-for="(item, i) in filtredUsersList"
                                  :key="i"
                                  :class="{'v-list-item--active': item.active}"
                                  style='min-height: 32px'
                                  :disabled='item.inviteStatus === "owner"'
                                >
                                  <v-list-item-title>
                                    <div
                                      class='flex items-center'
                                    >
                                      <v-simple-checkbox
                                        :value='item.selected'
                                        color='#8074c2'
                                        @input='v => {handleSelectedChange(item, v)}'
                                        :disabled='item.inviteStatus === "owner"'
                                      />
                                      <span class='ml-1 warehouse-list-title'>{{ item.firstName }} {{ item.lastName }}</span>
                                    </div>
                                  </v-list-item-title>
                                </v-list-item>
                              </v-list>
                              <p v-else class='px-2 py-1 text-center font-italic'>No Users Found</p>
                            </div>
                          </div>
                        </v-menu>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row class="justify-space-between">
                      <v-col cols="12" class="px-0">
                        <v-data-table
                          :headers="usersHeaders"
                          :items="selectedUsers"
                          :page.sync="usersPage"
                          :items-per-page="usersPerPage"
                          item-key="id"
                          hide-default-footer
                          @page-count="usersPageCount = $event"
                        >
                          <template :slot='"no-results"'>
                            <p class="text-h6 my-16">No Users found</p>
                          </template>
                          <template :slot='"no-data"'>
                            <p class="text-h6 my-16">No Users found</p>
                          </template>
                          <template v-slot:[`item.selected`]>
                            <v-simple-checkbox
                              color="#7972c0"
                              :ripple="false"
                            ></v-simple-checkbox>
                          </template>
                          <template v-slot:[`item.createdAt`]="{ item }">
                            {{ item.createdAt | formatDate(getDateTimeFormat) }}
                          </template>
                          <template v-slot:[`item.lastVisit`]="{ item }">
                            {{ item.lastVisit | formatDate(getDateTimeFormat) }}
                          </template>
                          <template v-slot:[`item.inviteStatus`]="{ item }">
                          <span
                            v-if="item.inviteStatus === 'accepted'"
                            style="
                              background-color: #d6f7e2;
                              color: #3d654d;
                              border-radius: 4px;
                            "
                            class="pa-1"
                          >
                            {{ item.inviteStatus }}
                          </span>
                            <span
                              v-else
                              style="
                              background-color: #fff1d6;
                              color: #b67501;
                              border-radius: 4px;
                            "
                              class="pa-1"
                            >
                            {{ item.inviteStatus }}
                          </span>
                          </template>
                          <template v-slot:[`item.actions`]="{ item }">
                            <v-row class="flex-nowrap">
                              <v-col cols="6" class="px-1" v-if='$getRight("userManagement")'>
                                <router-link class="ml-1" :to='{name: "EditUser", params: {id: item.id}}'>
                                  <img
                                    style="height: 16px; width: 16px"
                                    src="@/assets/icons/svg/draw.svg"
                                    title="Edit"
                                  />
                                </router-link>
                              </v-col>
                              <v-col cols="6" class="px-1">
                                <img
                                  v-if="item.inviteStatus !== 'owner'"
                                  style="height: 16px; width: 16px"
                                  src="@/assets/icons/svg/delete1.svg"
                                  @click="deleteUser(item.id)"
                                  class="cursor-point"
                                  title="Delete"
                                />
                              </v-col>
                            </v-row>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                    <v-row class="pagination-wrapper">
                      <v-col cols="5">
                        <span class="text-nowrap mr-2">Items per page</span>
                        <v-menu offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              text
                              outlined
                              v-bind="attrs"
                              v-on="on"
                              style="padding: 0; font-weight: 600"
                            >
                              {{ usersPerPage }}
                              <v-icon>mdi-menu-down</v-icon>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item
                              v-for="(item, index) in [5, 10, 20, 25, 50]"
                              :key="index"
                              link
                              @click="usersPerPage = item"
                            >
                              <v-list-item-title>{{ item }}</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-col>
                      <v-col cols="7" class="d-flex justify-end">
                        <v-pagination
                          v-model="usersPage"
                          :length="usersPageCount"
                          :total-visible="6"
                          color="#7972C0"
                        ></v-pagination>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
          <v-row class="mt-10 px-2">
            <v-col cols="12">
              <v-btn
                @click="handleCancel"
                depressed
                medium
                class="cancel-btn"
              >
                Cancel
              </v-btn>
              <v-btn
                @click="validate"
                depressed
                medium
                :disabled="!valid"
                class="save-item-btn save-btn"
              >
                Save
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <delete-single
      v-if='deleteSingle && isEdit'
      :role='deleteSingle.role'
      :usersCount='deleteSingle.usersCount'
      @doDelete='handleSingleDelete'
      @cancel='deleteSingle=null'
    />
    <UnsavedChangesPopup @confirm='confirmedCancel=true'/>
  </div>
</template>

<script>
import PageTitle from '@/components/page/PageTitle'
import CustomCircleProgressBar from '@/components/CustomCircleProgressBar'
import UnsavedChangesPopup from '@/components/popup/UnsavedChangesPopup'
import { firstCharUppercase } from '@/utils'
import deleteSingle from '@/components/roles/popups/deleteSingle'
import moment from 'moment'
import { mapGetters } from 'vuex'
import service from '@/services/roles'

const accessRightsForArray = [
  {
    name: 'Warehouse',
    key: 'warehouse'
  },
  {
    name: 'Category',
    key: 'category'
  },
  {
    name: 'Item',
    key: 'item'
  },
  {
    name: 'Custom Field',
    key: 'customField'
  }
]

export default {
  name: 'UsersRolesEditing',
  components: {
    PageTitle,
    'circle-progress': CustomCircleProgressBar,
    UnsavedChangesPopup,
    deleteSingle
  },
  data: () => ({
    isEdit: true,
    navSettingsOptions: [
      {
        index: 2,
        text: 'User Roles',
        to: {
          name: 'UsersRolesList'
        }
      },
      {
        index: 3,
        text: 'Edit Role'
      }
    ],
    valid: false,
    activeTab: 0,
    tabsItems: [
      {
        title: 'Setting Access',
        value: 'settings'
      },
      {
        title: 'Users',
        value: 'users'
      }
    ],
    item: {
      name: '',
      description: '',
      users: [],
      rights: {
        warehouseView: false,
        warehouseCreate: false,
        warehouseEdit: false,
        warehouseDelete: false,
        itemView: false,
        itemCreate: false,
        itemEdit: false,
        itemDelete: false,
        categoryView: false,
        categoryCreate: false,
        categoryEdit: false,
        categoryDelete: false,
        customFieldView: false,
        customFieldCreate: false,
        customFieldEdit: false,
        customFieldDelete: false,
        integrationManagement: false,
        inventoryImport: false,
        inventoryExport: false,
        reports: false,
        activityHistory: false,
        alertManagement: false,
        roleManagement: false,
        userManagement: false
      }
    },
    setupAccessRightsHeaders: [
      {
        text: '',
        align: 'start',
        sortable: false,
        value: 'name'
      },
      {
        text: 'Full Access',
        align: 'center',
        sortable: false,
        value: 'fullAccess',
        width: 120
      },
      {
        text: 'View',
        align: 'center',
        sortable: false,
        value: 'view',
        width: 120
      },
      {
        text: 'Create',
        align: 'center',
        sortable: false,
        value: 'create',
        width: 120
      },
      {
        text: 'Edit',
        align: 'center',
        sortable: false,
        value: 'edit',
        width: 120
      },
      {
        text: 'Delete',
        align: 'center',
        sortable: false,
        value: 'delete',
        width: 120
      }
    ],
    setupAccessRightsItems: [],
    accessRightsHeaders: [
      {
        text: '',
        align: 'center',
        sortable: false,
        value: 'active'
      },
      {
        text: '',
        align: 'start',
        sortable: false,
        value: 'name'
      },
      {
        text: 'Description',
        align: 'start',
        sortable: false,
        value: 'description'
      }
    ],
    accessRightsItems: [
      {
        name: 'Import',
        description: 'Ability to import inventory'
      },
      {
        name: 'Export',
        description: 'Ability to export inventory'
      },
      {
        name: 'Reports',
        description: 'Ability to create and save reports'
      },
      {
        name: 'Alerts Management',
        description: 'Set and configure alerts for items'
      },
      {
        name: 'Role Management',
        description: 'Ability to create roles and install them to users'
      },
      {
        name: 'Activity History',
        description: 'Access to activity history, viewing history for a selected period'
      },
      {
        name: 'User Management',
        description: 'Access to management of users'
      },
      {
        name: 'Integration Management',
        description: 'Access to integrations'
      }
    ],
    confirmedCancel: false,
    deleteSingle: null,
    nameRules: [
      v => !!v.length || 'Role name is required'
    ],
    usersHeaders: [
      {
        text: 'First Name',
        align: 'start',
        sortable: true,
        value: 'firstName'
      },
      {
        text: 'Last Name',
        value: 'lastName',
        sortable: true,
        align: 'start'
      },
      { text: 'Role', value: 'role', sortable: true, align: 'start' },
      { text: 'Email', value: 'email', sortable: true, align: 'start' },
      {
        text: 'Phone Number',
        value: 'phone',
        sortable: true,
        align: 'start'
      },
      { text: 'Created', value: 'createdAt', sortable: true, align: 'start' },
      {
        text: 'Last Active',
        value: 'lastVisit',
        sortable: true,
        align: 'start'
      },
      {
        text: 'Status',
        value: 'inviteStatus',
        sortable: true,
        align: 'start'
      },
      {
        text: '',
        value: 'actions',
        sortable: false,
        align: 'start'
      }
    ],
    usersPerPage: 5,
    usersPage: 1,
    usersPageCount: 0,
    filterUsers: '',
    filterUsersOptiones: [
      'All Users',
      'Confirmed Users',
      'Unconfirmed Users'
    ],
    addingUserMenuState: false,
    searchUsersInput: '',
    selectedUsers: [],
    itemIsLoading: true
  }),
  computed: {
    ...mapGetters('user', ['getDateTimeFormat']),
    ...mapGetters('user', {
      invitedUsers: 'invitedUsers'
    }),
    isSystem() {
      return this.item.system
    },
    filtredUsersList() {
      const usersFilter = users => {
        return users.filter(user => {
          if (this.isSystem && this.item.name === 'admin') return user.inviteStatus !== 'invited'
          return user.inviteStatus === 'accepted'
        })
      }
      if (this.searchUsersInput) {
        return usersFilter(this.invitedUsers.filter(item => {
          const name = `${item.firstName} ${item.lastName}`
          return name.toLowerCase().search(new RegExp(this.searchUsersInput.toLowerCase()), 'g') >= 0
        }))
      }
      return usersFilter(this.invitedUsers)
    },
    accessRightsImport: {
      get() {
        return this.item.rights.inventoryImport
      },
      set(v) {
        if (!this.item.system) {
          this.item.rights.inventoryImport = v
        }
      }
    },
    accessRightsExport: {
      get() {
        return this.item.rights.inventoryExport
      },
      set(v) {
        if (!this.item.system) {
          this.item.rights.inventoryExport = v
        }
      }
    },
    accessRightsReports: {
      get() {
        return this.item.rights.reports
      },
      set(v) {
        if (!this.item.system) {
          this.item.rights.reports = v
        }
      }
    },
    accessRightsActivityHistory: {
      get() {
        return this.item.rights.activityHistory
      },
      set(v) {
        if (!this.item.system) {
          this.item.rights.activityHistory = v
        }
      }
    },
    accessRightsAlertsManagement: {
      get() {
        return this.item.rights.alertManagement
      },
      set(v) {
        if (!this.item.system) {
          this.item.rights.alertManagement = v
        }
      }
    },
    accessRightsRoleManagement: {
      get() {
        return this.item.rights.roleManagement
      },
      set(v) {
        if (!this.item.system) {
          this.item.rights.roleManagement = v
        }
      }
    },
    accessRightsUserManagement: {
      get() {
        return this.item.rights.userManagement
      },
      set(v) {
        if (!this.item.system) {
          this.item.rights.userManagement = v
        }
      }
    },
    accessRightsIntegrationManagement: {
      get() {
        return this.item.rights.integrationManagement
      },
      set(v) {
        if (!this.item.system) {
          this.item.rights.integrationManagement = v
        }
      }
    }
  },
  watch: {
    invitedUsers: {
      deep: true,
      handler() {
        this.buildSelected()
      }
    },
    setupAccessRightsItems: {
      handler(arr, oldArr) {
        if (Array.isArray(oldArr) && oldArr.length) {
          for (let i = 0; i < arr.length; i++) {
            if (arr[i].name === 'Warehouse') {
              if (!arr[i].view) {
                this.handleAccessRightsItemChange('Item', 'view', false)
                this.handleAccessRightsItemChange('Category', 'view', false)
                this.handleAccessRightsItemChange('Custom Field', 'view', false)
              }
            }
          }
        }
      },
      deep: true
    }
  },
  filters: {
    formatDate: (v, format) => moment(v).format(format)
  },
  beforeRouteEnter(to, from, next) {
    if ((+to.params.id).isNaN) {
      next(vm => {
        vm.$router.replace({ name: 'UsersRolesList' })
      })
    } else {
      next()
    }
  },
  methods: {
    deleteUser(id) {
      this.invitedUsers.find(item => item.id === id).selected = false
      this.buildSelected()
    },
    handleCancel() {
      this.doCancel()
    },
    buildAccessRightsItems() {
      const itemRights = this.item.rights
      this.setupAccessRightsItems = accessRightsForArray.reduce((arr, current) => {
        const item = {
          name: current.name,
          view: itemRights[`${current.key}View`],
          create: itemRights[`${current.key}Create`],
          edit: itemRights[`${current.key}Edit`],
          delete: itemRights[`${current.key}Delete`]
        }
        item.fullAccess = item.view && item.create && item.edit && item.delete
        arr.push(item)
        return arr
      }, [])
    },
    handleAccessRightsItemChange(item, type, value) {
      if (!this.item.system) {
        const currentItem = accessRightsForArray.find(el => el.name === item)
        const currItem = this.setupAccessRightsItems.find(el => el.name === currentItem.name)
        if (type === 'fullAccess') {
          this.item.rights[`${currentItem.key}View`] = value
          this.item.rights[`${currentItem.key}Create`] = value
          this.item.rights[`${currentItem.key}Edit`] = value
          this.item.rights[`${currentItem.key}Delete`] = value
          currItem.view = value
          currItem.create = value
          currItem.edit = value
          currItem.delete = value
        } else if (type === 'view') {
          if (!value) {
            this.item.rights[`${currentItem.key}Create`] = value
            this.item.rights[`${currentItem.key}Edit`] = value
            this.item.rights[`${currentItem.key}Delete`] = value
            this.item.rights[`${currentItem.key}View`] = value
            currItem.view = value
            currItem.create = value
            currItem.edit = value
            currItem.delete = value
          } else {
            this.item.rights[`${currentItem.key}${firstCharUppercase(type)}`] = value
          }
          currItem.fullAccess = currItem.view && currItem.create && currItem.edit && currItem.delete
          if (item === 'Warehouse' && !value) {
            this.setupAccessRightsItems.forEach(rightsItem => {
              if (rightsItem.name !== 'Warehouse') rightsItem.view = false
            })
          }
          if (item !== 'Warehouse' && value) {
            this.setupAccessRightsItems.find(rightsItem => rightsItem.name === 'Warehouse').view = true
            this.item.rights.warehouseView = true
          }
        } else {
          this.item.rights[`${currentItem.key}${firstCharUppercase(type)}`] = value
          currItem.fullAccess = currItem.view && currItem.create && currItem.edit && currItem.delete
          if (value) {
            this.item.rights[`${currentItem.key}View`] = value
            currItem.view = value
          }
        }
      }
    },
    doCancel() {
      this.$router.push({ name: 'UsersRolesList' })
    },
    handleSingleDelete() {
      this.$store.dispatch('roles/deleteRole', [this.deleteSingle])
      this.deleteSingle = false
    },
    handleSelectedChange(item, v) {
      this.invitedUsers.find(user => user.id === item.id).selected = v
      this.buildSelected()
    },
    buildSelected() {
      this.selectedUsers = this.invitedUsers.filter(item => item.selected)
      this.item.users = this.selectedUsers.map(item => item.id)
    },
    async validate () {
      const payload = this.item
      payload.active = true
      const response = await service.editRole(payload)
      if (response?.data?.error?.type === 200) {
        this.$store.dispatch('roles/loadRoles')
        this.confirmedCancel = true
        this.$router.push({ name: 'UsersRolesList' })
      }
    }
  },
  async created() {
    const vm = this
    const response = await service.readRole({ id: +vm.$route.params.id })
    if (response?.data?.error?.type === 200) {
      const users = response.data.data.users
      vm.invitedUsers.forEach(item => {
        if (users.find(user => user.id === item.id)) {
          item.selected = true
        }
      })
      const item = response.data.data
      item.users.forEach(user => {
        const findedUser = vm.invitedUsers.findIndex(invitedUser => invitedUser.id === user.id)
        if (findedUser >= 0) {
          vm.invitedUsers[findedUser].selected = true
        }
      })
      delete item.users
      vm.item = item
      vm.item.users = []
      this.item.users = this.invitedUsers.filter(item => item.selected).map(item => item.id)
      await this.buildSelected()
      await vm.buildAccessRightsItems()
      this.itemIsLoading = false
    } else {
      vm.$store.subscribeAction(action => {
        if (action.type === 'closeSubmitFormErrorPopup') {
          vm.$router.replace({ name: 'UsersRolesList' })
        }
      })
    }
  }
}
</script>

<style lang='scss'>
  #app .text-breadcum-settings {
    color: rgba(0, 0, 0, 0.87);
    text-decoration: none;
    i {
      text-decoration: none;
    }
  }
  #app a.text-breadcum-settings {
    color: rgba(0, 0, 0, 0.87);
    transition: 0.2s linear;
    &:hover {
      color: #7671bd
    }
  }

  .roles-tabs {
    position: relative;
    &::after {
      content: '';
      position: absolute;
      z-index: 1;
      bottom: 0;
      height: 1px;
      left: 0;
      right: 0;
      background-color: rgba(0, 0, 0, 0.2);
    }
    .v-item-group {
      position: relative;
      z-index: 2;
    }
  }
  .roles-tab {
    border-radius: 5px 5px 0 0;
    color: #958fcb !important;
    font-weight: 600;
    &.v-tab--active {
      border-left: 1px solid rgba(0, 0, 0, 0.2);
      border-top: 1px solid rgba(0, 0, 0, 0.2);
      border-right: 1px solid rgba(0, 0, 0, 0.2);
      border-bottom: 1px solid #f5f5f5;
      color: rgba(#000, 0.83) !important;
      position: relative;
      z-index: 2;
    }
  }
  .v-tabs-slider-wrapper {
    height: 1px !important;
    z-index: 3;
  }
</style>
